import { useQuery } from "@apollo/client";
import { GET_POPULAR_STORIES } from "../graphql/stories";
import type { Story } from "../types/models";

interface PopularStoriesData {
  mostPopularStories: Story[];
}

interface PopularStoriesVariables {
  limit?: number;
}

// usePopularStories hook - Accept limit parameter (default 5)
export const usePopularStories = (limit = 5) => {
  const { data, loading, error } = useQuery<PopularStoriesData, PopularStoriesVariables>(
    GET_POPULAR_STORIES,
    {
      variables: { limit },
    }
  );

  // Filter out deleted stories as a defensive measure (backend should already filter)
  const stories = (data?.mostPopularStories || []).filter(
    (story) => story.isDeleted !== true
  );

  return {
    stories,
    isLoading: loading,
    error,
  };
};

